module.exports = __webpack_public_path__ + "static/media/9 Rajendra 2021 FPO Alert.1efdaf65.pdf";